export const PLAYER_INITIALS_DROPDOWN_VALUE = 'player_initials';
export const MY_PROFILE_DROPDOWN_HREF = '/my-profile';
export const MY_PROFILE_DROPDOWN_LABEL = 'my profile';
export const MY_PROFILE_DROPDOWN_VALUE = 'my_profile';
export const SIGN_OUT_DROPDOWN_LABEL = 'sign out';
export const SIGN_OUT_DROPDOWN_VALUE = 'sign_out';
